import React from 'react'
import { useTranslate } from '@ur-solutions/react-hooks'
import { useModuleConfig, useUser } from '@/utils/hooks'
import { getUsersHighestPrioritySalaryWorkTime } from '@/modules/companies/util'
import type { TimesheetsModuleConfig } from '@/modules/companies'
import { Module } from '@/modules/companies'
import { TimeEntryFormAPI } from './components/TimeEntryFormAPI'

export const CreateTimeEntry: React.JSX.CFC = () => {
  const translations = useTranslate({
    newTimeEntry: 'timesheets.new-time-entry',
    loading: 'common.loading-ellipsis',
  })
  const user = useUser()
  const { moduleConfig } = useModuleConfig<TimesheetsModuleConfig>(
    Module.TIMESHEETS
  )

  const salaryWorkTime = getUsersHighestPrioritySalaryWorkTime(
    user,
    moduleConfig
  )

  return (
    <div className="flex flex-col gap-6 p-4 md:p-8">
      <header>
        <h1 className="text-4xl font-bold">{translations.newTimeEntry}</h1>
      </header>

      <div className="w-full rounded-2xl bg-white p-5 shadow-card md:p-8">
        {salaryWorkTime ? (
          <TimeEntryFormAPI salaryWorkTime={salaryWorkTime} />
        ) : (
          translations.loading
        )}
      </div>
    </div>
  )
}
